export const dialogCfg = [{
	name: 'AlertDialog',
	component: 'alertDialog'
}];
